import { Button, Popover } from 'antd'
import { isEmpty } from 'lodash'
import { observer } from 'mobx-react-lite'
import React, { useState } from 'react'
import Select, { StylesConfig } from 'react-select'
import { useTranslation } from 'react-i18next'
import { GLOBAL_CLIENT } from 'src/helpers/GlobalClient'
import { useStore } from 'src/hooks'

/**
 * Gan MOT designer cho NHIEU viec dang chon trong bang quan ly viec.
 *
 * Component nay chi lo phan chon designer roi bao len cho man cha; viec goi API
 * lan luot tung don, gom loi va tai lai danh sach dung chung `runBulkAction` voi
 * cac thao tac hang loat khac (hoan thanh, huy) de hanh vi giong het nhau.
 */

type BulkAssignJobProps = {
   // So viec trong danh sach chon ma thuc su gan duoc
   assignableCount: number
   loading?: boolean
   onAssign: (designer: any) => void
}

const colourStyles: StylesConfig<true> = {
   control: (styles: any) => ({ ...styles, backgroundColor: 'white', minWidth: 260 }),
   option: (styles: any, { isDisabled, isFocused, isSelected }) => ({
      ...styles,
      backgroundColor: isDisabled
         ? undefined
         : isSelected
         ? 'rgba(54,179,126,0.3);'
         : isFocused
         ? 'rgba(54,179,126,0.1);'
         : undefined,
      color: 'default',
      cursor: 'default',
      ':active': {
         ...styles[':active'],
         backgroundColor: 'rgba(54,179,126,0.3);'
      }
   })
}

const BulkAssignJob: React.FC<BulkAssignJobProps> = observer(({ assignableCount, loading, onAssign }) => {
   const { t } = useTranslation()
   const UserStore = useStore('UserStore')
   const { listDesigner } = UserStore
   const [open, setOpen] = useState(false)
   const [designer, setDesigner] = useState<any>(null)

   const handleAssign = () => {
      if (!designer?.id) return
      setOpen(false)
      onAssign(designer)
   }

   const content = (
      <div style={{ width: 280 }}>
         <p style={{ fontWeight: 'bold', marginBottom: 8 }}>{t(GLOBAL_CLIENT.assignJobFor)}</p>
         <Select
            autoFocus
            value={designer}
            options={listDesigner?.rows}
            onChange={setDesigner}
            getOptionLabel={(option: any) => (isEmpty(option?.name) ? option?.email : option?.name)}
            getOptionValue={(option: any) => String(option?.id)}
            styles={colourStyles}
            classNamePrefix="select"
            menuPlacement="auto"
            isSearchable
         />
         <Button
            type="primary"
            block
            style={{ marginTop: 12 }}
            disabled={!designer?.id}
            onClick={handleAssign}
         >{`${t(GLOBAL_CLIENT.assignJob)} (${assignableCount})`}</Button>
      </div>
   )

   return (
      <Popover
         visible={open}
         onVisibleChange={setOpen}
         trigger="click"
         placement="bottomLeft"
         content={content}
         destroyTooltipOnHide
      >
         <Button loading={loading} disabled={assignableCount === 0}>
            {`${t(GLOBAL_CLIENT.ganviechangloat)} (${assignableCount})`}
         </Button>
      </Popover>
   )
})

export default BulkAssignJob
